import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-cuestionarios-salud',
  templateUrl: './cuestionarios-salud.component.html',
  styleUrls: ['./cuestionarios-salud.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CuestionariosSaludComponent implements OnInit {
  private title = 'Cuestionarios Salud - Rastreator.com™';
  public baseImageUrl: string;
  public baseDocUrl: string;

  constructor() {}

  public ngOnInit(): void {
    this.baseImageUrl = '/assets/img/logos/';
    this.baseDocUrl = '/assets/docs/';
    this.loadScript('/assets/js/cuestionarios-salud.js');
  }

  public loadScript(url: string): void {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.src = url;
    script.async = false;
    script.defer = true;
    script.title = this.title;
    body.appendChild(script);
  }
}
